import React from "react";
import Layout from "@components/layout";
import SEO from "@components/seo";
import Controls from "@components/Controls/controls";
import UniplacesFullContainer from "@components/UniplacesFullContainer/uniplacesFullContainer";
import HeroSection from "@components/HeroSection/heroSection";
import PartnersList from "@components/partnersPage/PartnersList/partnersList";
import PartnersCta from "@components/partnersPage/PartnersCta/partnersCta";

const partnersTemplate = ({
  data: {
    partners,
    partnersHeroHeading: {
      0: { text: heroHeading },
    },
    partnersHeroSubheading: {
      0: { text: heroSubheading },
    },
    partnersHeroImage,
    partnersCtaTitle: {
      0: { text: ctaTitle },
    },
    partnersCtaSubtitle: {
      0: { text: ctaSubtitle },
    },
    partnersCtaText: {
      0: { text: ctaText },
    },
    partnersCtaLink: { url: ctaLink },
  },
  pageContext: { locale },
}) => {
  return (
    <Layout locale={locale}>
      <SEO
        titleKey="seo.partners.title"
        descriptionKey="seo.partners.description"
        imageUrl={partnersHeroImage.url}
        lang={locale}
      />
      <HeroSection
        heroHeading={heroHeading}
        heroSubheading={heroSubheading}
        heroImage={partnersHeroImage} 
      />
      <UniplacesFullContainer>
        <React.Fragment>
          {partners && <PartnersList partners={partners} />}
          <PartnersCta
            ctaTitle={ctaTitle}
            ctaSubtitle={ctaSubtitle}
            ctaText={ctaText}
            ctaLink={ctaLink}
          />
          <Controls />
        </React.Fragment>
      </UniplacesFullContainer>
    </Layout>
  );
};

export default partnersTemplate;
